import { state } from "../store";
import { setRoot } from "../render";

export function renderStep3() {
  const draft = state.draft;
  setRoot(`
    <header class="text-center pb-3 border-b">
      <h1 class="font-bold text-lg">👤 お名前・連絡方法</h1>
      <p class="text-xs text-gray-500 mt-1">Step 3 / 5</p>
    </header>

    <label class="block mt-4">
      <span class="text-sm text-gray-600">お名前</span>
      <input id="name-input" type="text" value="${escapeHtml(draft.customer_name)}"
        class="mt-1 w-full border rounded p-2" placeholder="山田太郎" />
    </label>

    <div class="mt-4">
      <span class="text-sm text-gray-600">連絡方法</span>
      <div class="mt-1 grid grid-cols-2 gap-2">
        <button data-method="zoom" class="method-btn border rounded p-3 text-center">📹 オンライン面談</button>
        <button data-method="line_call" class="method-btn border rounded p-3 text-center">📞 LINE電話</button>
      </div>
    </div>

    <div class="mt-auto pt-4 flex gap-2">
      <button id="back-btn" class="flex-1 bg-gray-300 text-gray-800 py-3 rounded">戻る</button>
      <button id="next-btn" disabled class="flex-[2] bg-gray-300 text-white py-3 rounded font-bold">次へ</button>
    </div>
  `);

  // 既存選択を反映
  if (draft.contact_method) {
    const sel = document.querySelector<HTMLElement>(`.method-btn[data-method="${draft.contact_method}"]`);
    if (sel) selectMethod(draft.contact_method, sel);
  }

  document.querySelectorAll<HTMLButtonElement>(".method-btn").forEach((b) => {
    b.addEventListener("click", () => selectMethod(b.dataset.method as any, b));
  });

  document.getElementById("name-input")!.addEventListener("input", validate);

  document.getElementById("back-btn")!.addEventListener("click", async () => {
    const { renderStep2 } = await import("./step2Time");
    renderStep2();
  });
}

function selectMethod(method: "zoom" | "line_call", btn: HTMLElement) {
  state.draft.contact_method = method;
  document.querySelectorAll<HTMLElement>(".method-btn").forEach((b) => {
    b.className = "method-btn border rounded p-3 text-center";
  });
  btn.className = "method-btn bg-brand text-white rounded p-3 text-center font-bold";
  validate();
}

function validate() {
  const name = (document.getElementById("name-input") as HTMLInputElement).value.trim();
  state.draft.customer_name = name;
  const ok = !!name && !!state.draft.contact_method;
  const next = document.getElementById("next-btn") as HTMLButtonElement;
  next.disabled = !ok;
  next.className = ok
    ? "flex-[2] bg-brand text-white py-3 rounded font-bold"
    : "flex-[2] bg-gray-300 text-white py-3 rounded font-bold";
  if (ok) {
    next.onclick = async () => {
      const { renderStep4 } = await import("./step4Topic");
      renderStep4();
    };
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[c]!));
}
